module.exports = __webpack_public_path__ + "img/授权.6d4494e9.svg";